module.exports = __webpack_public_path__ + "static/media/f3.383565de.png";